import { Navigate } from "react-router-dom";
import Listpost from "./Listpost";
import Auth from "./Auth";
import TopNavBar from "./TopNavBar";

const Dashboard = () => {

  const auth = Auth();

  if (auth === null) {
    return <p>Loading...</p>;
  }

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <div className="min-h-full">
        <TopNavBar />
        <main>
          <div className="mx-auto max-w-7xl px-2 py-6 sm:px-6 lg:px-8">
            <Listpost/>
          </div>
        </main>
      </div>        
    </>
  );
};

export default Dashboard;
